import { zIndexes } from "@shared/common/Themes/AppTheme";
import React, { FC, PropsWithChildren } from "react";
import useMedia from "utils/hooks/useMedia";
import {
  INTERCOM_TOTAL_SIZE,
  IS_TELEGRAM_WEB_APP,
  MOBILE_SEARCH,
} from "common/constants";
import AntDrawer, { DrawerProps } from "antd/es/drawer";
import styled, { css } from "styled-components";
import { OverlayWrapper } from "common/Overlays/Overlay";
import TelegramAppHeader from "common/Home/Header/TelegramAppHeader";
import { isMobile } from "react-device-detect";
import { Inset } from "@shared/types";
import { hexToRGB } from "@shared/utils/misc.ts";

const Drawer: FC<PropsWithChildren<DrawerProps>> = ({ children, ...props }) => {
  const isMobileScreen = useMedia(
    [`(max-width: ${MOBILE_SEARCH})`],
    [true],
    false
  );
  const defaultProps: DrawerProps = {
    width: DEFAULT_DRAWER_WIDTH,
    placement: "right",
    destroyOnClose: true,
    zIndex: zIndexes.drawer,
    styles: {
      body: {
        padding: isMobileScreen ? 12 : 36,
        overflow: "auto",
      },
    },
  };

  return (
    <StyledDrawer
      push={false}
      {...defaultProps}
      {...props}
      $isMobile={isMobileScreen}
      title={
        IS_TELEGRAM_WEB_APP &&
        props.placement !== "bottom" && <TelegramAppHeader />
      }
    >
      {children}
    </StyledDrawer>
  );
};

export default Drawer;

export const DEFAULT_DRAWER_WIDTH = 660;

export const drawerStyles = css<{
  $isMobile?: boolean;
  $safeAreaInset?: Inset;
  $contentSafeAreaInset?: Inset;
}>`
  .ant-drawer-content-wrapper {
    max-width: 100%;
  }
  .ant-drawer-content {
    padding-bottom: ${(p) => p.$safeAreaInset?.bottom ?? 0}px;
  }
  .ant-drawer-content,
  .ant-drawer-body,
  .ant-drawer-wrapper-body {
    background: ${(p) => p.theme.colors.layoutBgColor};
  }
  .ant-drawer-header {
    border-bottom: none;
    padding: 0;
  }
  .ant-drawer-close {
    padding: 12px !important;
    z-index: 40;
    color: ${(p) => p.theme.colors.textColor};
    top: ${(p) => {
      const addPadding = IS_TELEGRAM_WEB_APP && isMobile;
      const topPadding = addPadding
        ? (p.$safeAreaInset?.top ?? 0) + (p.$contentSafeAreaInset?.top ?? 0)
        : 0;
      return topPadding + (p.$isMobile ? 3 : 5);
    }}px;
    position: absolute;
    right: 0;
    &:hover {
      color: ${(p) => hexToRGB(p.theme.colors.textColor, 0.7)};
      background: ${(p) => hexToRGB(p.theme.colors.lightestGrey, 0.2)};
    }
  }
  ${OverlayWrapper} {
    background: ${(p) => p.theme.colors.layoutBgColor};
  }
`;
const StyledDrawer = styled(AntDrawer)<{ $isMobile: boolean }>`
  .ant-drawer-body {
    padding-bottom: ${INTERCOM_TOTAL_SIZE}px !important;
  }
`;
